import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerOneVolunteers from "../components/DashBoardLayerOneVolunteers";

const HomePageOneVolunteers = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Dashboard Green Volunteers" tooltipContent="Add New Complaint" linkTo="/complains/add"  requiredPermission={{ module: 'complaints', action: 'create' }}/>
        

        {/* DashBoardLayerOne */}
        <DashBoardLayerOneVolunteers />

      </MasterLayout>
    </>
  );
};

export default HomePageOneVolunteers;
